import type { SVGProps } from "react"

export default function SearchIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="8.5"
        cy="8.5"
        r="7.5"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line
        x1="14.4142"
        y1="14"
        x2="18"
        y2="17.5858"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}
